import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { OptionType } from 'src/AppState/ConfigState/types';

export class LanguagesState {
    constructor(
        private readonly configState: ConfigState,
    ) {}

    getOperatorLanguagesList = (): Array<OptionType> => {
        return this.configState.config.languages;
    }

    getDefaultLanguage = (): OptionType | null => {
        return this.getOperatorLanguagesList()[0] ?? null;
    }

    getLanguageByValue = (value: string): OptionType | null => {
        return this.getOperatorLanguagesList().find(language => language.value === value) ?? null;
    }

    getNonDefaultLanguagesList = (): Array<OptionType> => {
        return this.getOperatorLanguagesList().slice(1);
    }
}
